import { ElementType, ReactNode } from 'react';
import { StaticImageData } from 'next/image';
import cn from 'classnames';
import FeatureItem from './FeatureItem';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import UpgradePlanButton from '@/creditflowresearch/ui/common/components/UpgradePlanButton';
import Image from '@framework/router/Next/Image';
import DesktopOnlyCaption from './DesktopOnlyCaption';

import styles from './styles.module.scss';

interface IProps {
  title: string,
  description: ReactNode,
  features: string[],
  image: StaticImageData | string,
  imageCaption?: ReactNode,
  isLoginButton?: boolean,
  isDoubleImage?: boolean,
  customButton?: ElementType,
  isDesktopOnly?: boolean,
}

const NoAccessOverlay = ({
  title,
  description,
  features,
  isLoginButton = false,
  image,
  imageCaption,
  isDoubleImage = false,
  customButton: CustomButton,
  isDesktopOnly = false,
}: IProps) => {
  const renderButton = () => {
    if (CustomButton) {
      return <CustomButton />;
    }
    if (isLoginButton) {
      return <LogInButton withIcon={ false } className={ styles.actionButton } />;
    }
      return <UpgradePlanButton className={ styles.actionButton } />;
  };

  const getButton = (isDesktopOnly = false) => (
    <div className={ styles.buttonWrapper }>{ isDesktopOnly && <DesktopOnlyCaption /> }
      <div className={ cn({ [styles.mobileVisible]: isDesktopOnly }) }>{ renderButton() }</div>
    </div>
  );

  return (
    <div className={ styles.container } data-test="noAccessOverlay">
      <div className={ cn(styles.content, { [styles.isDoubleImage]: isDoubleImage }) }>
        <div>
          <h1>{ title }</h1>
          <div className={ styles.description }>{ description }</div>
          { features.map((item) => <FeatureItem key={ item } text={ item } />) }
          { getButton(isDesktopOnly) }
        </div>
        <div>
          <Image
            src={ image }
            width={ isDoubleImage ? 722 : 588 }
            height={ isDoubleImage ? 475 : 406 }
            alt={ title }
            preload
          />
          { imageCaption && <div className={ styles.caption }>{ imageCaption }</div> }
        </div>
      </div>
    </div>
  );
};

export default NoAccessOverlay;
